import React from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNameProps } from './classNames-6a4763fd.js';
import { b as addMarginClasses, m as marginProps } from './spacing-d13ff368.js';

function Icon({
  type,
  size,
  className,
  margin,
  color
}) {
  let cssClasses = ['st_icon', "st_icon--" + size];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addMarginClasses(margin, cssClasses);
  if (color) cssClasses.push("st_icon--color-" + color);
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: cssClasses.join(' ')
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-" + type
  }));
}

Icon.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg']),

  /** type of icon */
  type: PropTypes.string.isRequired,

  /** extra CSS classes, if any */
  className: classNameProps,

  /** margin for icon, if any */
  margin: marginProps,

  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white'])
};
Icon.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export default Icon;
